import { useState } from 'react';
import { Dialog, DialogPortal, DialogContent, DialogTitle, DialogFooter } from '../ui/dialog';
import { AlertTriangle, X } from 'lucide-react';
import { DialogDescription } from '@radix-ui/react-dialog';
import SelectCompset from '../select/SelectCompset';
import DatePicker from '../DatePicker';
import { Button } from '../ui/button';
import { useCompset } from '@/contexts/CompsetContext';
import { toast } from 'sonner';
import ButtonLoader from '../ButtonLoader';
import { Badge } from '../ui/badge';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';
import { usePlans } from '@/contexts/PlanRulesContext';

function RunCompsetModal({ open, onClose, loading, onLoadingChange, updateStep }) {

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedCompset, setSelectedCompset] = useState("");

    const { compsets, runCompset, onSuccessfullCompsetRun } = useCompset();
    const [compsetError, setCompsetError] = useState("");

    const { isPlanActive } = usePlans();

    const onChange = (value) => {
        setSelectedCompset(value)
    }

    const onCloseModal = () => {
        setSelectedDate(null)
        setSelectedCompset("")
        onClose()
        setCompsetError("")
    }


    const onRunClick = async () => {

        setCompsetError("")

        if (!isPlanActive) {
            setCompsetError("Your plan has expired. Please renew or upgrade to continue.")
            return
        }

        if (!selectedCompset) {
            toast.error("Select the CompSet you want to execute")
            return
        }

        if (!selectedDate) {
            toast.error("Select the date to execute compset")
            return
        }

        const exist = compsets?.user_compsets?.find(comp => comp?.compset_id == selectedCompset)

        if (!exist) {
            toast.error("Unable to find the compset")
            return
        }


        if (exist?.refresh_remain <= 0) {
            setCompsetError("You have exceeded the refresh limit for today.")
            return
        }


        try {
            onLoadingChange(true)
            setTimeout(() => {
                updateStep(1)
            }, 4000)

            const isOk = await runCompset(selectedDate, selectedCompset, exist?.compset_name)
            if (isOk) {
                toast.success("CompSet executed successfully!")
                onCloseModal()
                await onSuccessfullCompsetRun(exist)
            }

        } catch (error) {
            apiErrorHandler(error)
        } finally {
            onLoadingChange(false)
            updateStep(0)
        }
    }

    return (
        <Dialog open={open} onOpenChange={onCloseModal} >
            <DialogPortal>
                <DialogContent>
                    <DialogTitle>
                        <div className='flex justify-between items-center'>
                            <section>
                                <p className='text-base font-primary' > Refresh Compset </p>
                                <p className='text-sm text-gray-500 font-primary'> Get the most current data from all your sources. This will use one credit.  </p>
                            </section>
                            <X
                                className='cursor-pointer'
                                size={20}
                                onClick={onCloseModal}
                            />
                        </div>
                    </DialogTitle>
                    <DialogDescription>
                        <div className='!mb-4'>
                            <p className='text-sm mb-1'> Select Compset </p>
                            <SelectCompset
                                value={selectedCompset}
                                onChange={onChange}
                            />
                        </div>
                        <div className=''>
                            <section className='flex justify-between'>
                                <p className='text-sm mb-1'> Pick Start Date </p>
                                <p className='text-sm text-gray-600'> 30 days out </p>
                            </section>
                            <DatePicker
                                value={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                            />
                        </div>
                        {
                            compsetError && (
                                <div className="bg-orange-50 flex items-center gap-2 border border-orange-200 rounded-md p-3 mt-3">
                                    <AlertTriangle className="h-4 w-4 text-orange-700" />
                                    <p className="w-full text-sm text-orange-700">
                                        {compsetError}
                                    </p>
                                </div>
                            )
                        }
                    </DialogDescription>
                    <DialogFooter className={'gap-2'}>
                        <Button
                            onClick={onCloseModal}
                            disabled={loading}
                            className="px-4 rounded-md bg-red-600 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={onRunClick}
                            disabled={loading}
                        >
                            <ButtonLoader
                                text={"Run Now"}
                                loading={loading}

                            />
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </DialogPortal>
        </Dialog>
    );
}

export default RunCompsetModal;